export const comments_5588992 = {"data":{"data":[],"links":{}}}